import { GET_MITRA, SET_LOADING_MITRA, SET_PAGINATION_MITRA } from '../constant';

const initialState = {
  mitra: [],
  mitraPagination: 0,
  loadingMitra: false,
  totalMitra: 0,
};

const mitraReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_MITRA: {
      return {
        ...state,
        loadingMitra: action?.payload,
      };
    }
    case SET_PAGINATION_MITRA: {
      return {
        ...state,
        mitraPagination: action?.payload,
      };
    }
    case GET_MITRA: {
      return {
        ...state,
        mitra: action?.payload?.data || [],
        totalMitra: action?.payload?.total,
        loadingMitra: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default mitraReducer;
